import type { PokemonCardWithSet } from '../card/card'
import type { FullPokemonCard } from '../carddetector/types'
import type { Locale } from '../generated/prisma/client'

export const STANDARD_CONDITIONS = ['Mint', 'NearMint', 'Excellent', 'Good', 'Played', 'Poor'] as const

export type StandardCondition = (typeof STANDARD_CONDITIONS)[number]

export type InventoryCard = {
  id: string
  userId: string
  inventoryId: string
  cardId: string
  locale: Locale
  card?: FullPokemonCard
  condition: StandardCondition
  priceWhenAdded: number | null
  addedAt: Date
  storageLocationId: string | null
  storageLocation?: StorageLocation | null
}

export type Inventory = {
  id: string
  userId: string
  cards?: InventoryCard[]
}

export type StorageLocation = {
  id: string
  name: string
  description: string
  createdAt: Date
  updatedAt: Date
}

export type InventoryCardWithCard = InventoryCard & { card: PokemonCardWithSet }
export type InventoryCardWithFullCard = InventoryCard & { card: FullPokemonCard }
export type InventoryWithCards = Inventory & { cards: InventoryCardWithCard[] }
export type InventoryWithFullCards = InventoryWithCards & { cards: InventoryCardWithFullCard[] }
